<template>
  <div class="chart-wrapper">
    <Bar 
      class="custom-class" 
      :style="{ minWidth: computedMinWidth }"
      :chart-options="chartOptions" 
      :chart-data="chartData" 
      :chart-id="chartId"
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  components: { Bar },
  props: {
    chartId: { type: String, default: 'bar-chart' },
    dashboardData: { type: Array, default: () => [] },
    // ДОБАВЛЯЕМ НОВЫЙ ПРОПС: передаем текущий формат (day, week, month, quarter)
    currentFormat: { type: String, default: 'day' } 
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            labels: { font: { family: 'Inter', size: 14 }, color: '#323c4d' }
          },
          tooltip: {
            callbacks: {
              label: (tooltipItem) => `Пользователи: ${tooltipItem.raw.toLocaleString('ru-RU')}`
            }
          }
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              font: { family: 'Inter', size: 12 },
              color: '#636e72',
              maxRotation: 45, // Наклон текста, если места мало
              minRotation: 0
            }
          },
          y: {
            beginAtZero: true,
            ticks: { font: { family: 'Inter', size: 12 }, color: '#636e72' }
          }
        }
      }
    }
  },
  computed: {
    // 1. УМНАЯ ШИРИНА: Адаптируемся под формат
    computedMinWidth() {
      const count = this.dashboardData.length;
      
      // Если данных нет, возвращаем 100%
      if (count === 0) return '100%';

      // Рассчитываем, сколько пикселей нужно выделить на 1 столбец в зависимости от формата
      let pixelsPerItem = 0;
      
      switch (this.currentFormat) {
        case 'day':
          pixelsPerItem = 25; // Узкие столбцы, график будет длинным со скроллом
          break;
        case 'week':
          pixelsPerItem = 40; // Средние столбцы
          break;
        case 'month':
          pixelsPerItem = 60; // Широкие столбцы
          break;
        case 'quarter':
          return '100%'; // Кварталы (4 точки в год) всегда умещаем в экран без скролла
      }

      // Если общая ширина получается меньше ширины экрана, оставляем 100% (0)
      // Если больше — возвращаем рассчитанную ширину в пикселях (появится скролл)
      const calculatedWidth = count * pixelsPerItem;
      return count > 15 ? `${calculatedWidth}px` : '100%'; 
    },

    // 2. ДАННЫЕ И ТОЛЩИНА СТОЛБЦОВ
    chartData() {
      if (!this.dashboardData || this.dashboardData.length === 0) {
        return { labels: [], datasets: [] };
      }

      // Настраиваем максимальную толщину столбца в зависимости от формата
      let maxThickness = 30;
      if (this.currentFormat === 'month') maxThickness = 60;
      if (this.currentFormat === 'quarter') maxThickness = 100;

      return {
        labels: this.dashboardData.map(item => item.period),
        datasets: [
          {
            label: 'Количество пользователей',
            backgroundColor: '#14BF91',
            data: this.dashboardData.map(item => item.basic),
            borderRadius: 4,
            minBarLength: 5, // Если значение = 1, столбец все равно будет высотой 5px
            maxBarThickness: maxThickness // Ограничиваем толщину
          }
        ]
      };
    }
  }
}
</script>

<style scoped>
.chart-wrapper {
  width: 100%;
  overflow-x: auto; /* Скролл появляется только тогда, когда minWidth > 100% */
  overflow-y: hidden;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.custom-class {
  height: 352px;
  position: relative;
}

/* Красивый скроллбар для Webkit (Chrome, Safari) */
.chart-wrapper::-webkit-scrollbar {
  height: 8px;
}
.chart-wrapper::-webkit-scrollbar-track {
  background: transparent;
}
.chart-wrapper::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 4px;
}
</style>